export const languageFlagMapping: Record<string, string> = {
  fr: '🇫🇷',
  en: '🇬🇧',
}

export const languageLabelMapping: Record<string, string> = {
  fr: 'Français',
  en: 'English',
}
